const handleAlertClose = (closeButton: HTMLButtonElement) => {
  const parentElement = closeButton.parentElement;

  const timer = setTimeout(() => {
    parentElement?.classList.add("--close");
    clearTimeout(timer);
  }, 5000);

  closeButton.addEventListener("click", () => {
    parentElement?.classList.add("--close");
    clearTimeout(timer);
  });
};

export const initCopyLink = () => {
  const copyButtons = document.querySelectorAll<HTMLAnchorElement>("[data-copy]");

  if (copyButtons.length === 0) return;

  const alert = document.getElementById("alert");
  const alertCloseButton = alert?.querySelector("button")!;

  for (const copyButton of copyButtons) {
    copyButton.addEventListener("click", (event: PointerEvent) => {
      event.preventDefault();

      if (alert?.classList.contains("--close")) {
        alert?.classList.remove("--close");
      }

      alert?.classList.add("--open");

      handleAlertClose(alertCloseButton);

      navigator.clipboard.writeText(window.location.href);
    });
  }
};
